import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/base-config',
    name: 'BaseConfig',
    component: () => import('@/layouts/main/index.vue'),
    redirect: 'BaseConfigSizePosition',
    meta: {
      title: '基础配置',
      icon: 'components',
      noCache: false,
      auth: true,
    },
    children: [
      {
        path: 'prompt-manage/list',
        name: 'BaseConfigPromptManage',
        component: () => import('@/modules/base-config/prompt-manage/views/list/index.vue'),
        meta: {
          title: 'prompt管理',
          auth: true,
        },
      },
    ],
  },
] as IRouteConfig[];
